module.exports = __webpack_public_path__ + "static/img/1-2.8867f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/1-2.png
// module id = 37ra
// module chunks = 10